import React from 'react';

import {View, Text, TouchableOpacity, Alert} from 'react-native';
import {useSelector} from 'react-redux';
import Timer from 'src/ScavengerHunt_v2/Game/Timer';

import {setHuntTimerFinish} from 'src/Utils/huntFunctions_classic';

const ClassicHuntHeaderTimer = ({
  handlePress,
  disabled,
  current_screen = {},
  style = {},
}) => {
  const classicChallengeList = useSelector(
    (state) => state.game_v2?.classicChallengeList,
  );

  const allChallenges = useSelector((state) => state.game_v2?.allChallenges);

  const locations = useSelector((state) => state.game_v2?.locations);

  const timerLimitMinutes = useSelector(
    (state) => state.game_v2?.timerLimitMinutes,
  );
  const timerStart = useSelector((state) => state.game_v2?.timerStart);
  const timerFinish = useSelector((state) => state.game_v2?.timerFinish);
  console.log('InHuntDisplay Timer', {
    timerStart,
    timerFinish,
    timerLimitMinutes,
  });
  const groupInfo = useSelector((state) => state.groupInfo || {});
  const {
    score = 0,
    classic_hunt = false,
    isBarHunt = false,
    huntPaused,
  } = groupInfo;

  const challengesComplete = classicChallengeList?.reduce?.((acc, key) => {
    let challenge = allChallenges[key];

    if (challenge?.type === 'location') {
      let isCheckedIn = !!locations[challenge?.locationId]?.completeTime;
      let initialComplete = isCheckedIn ? 1 : 0;
      let locaChalsComplete = (challenge?.challengeList || []).reduce(
        (sum, chalId) => {
          if (allChallenges[chalId]?.completeTime) {
            return sum + 1;
          }
          return sum;
        },
        initialComplete,
      );
      return acc + locaChalsComplete;
    } else if (!!challenge?.completeTime) {
      return acc + 1;
    }
    return acc;
  }, 0);

  const completionPercent =
    (challengesComplete /
      (classicChallengeList?.length +
        (Object.keys(allChallenges || {}).length || 0))) *
    100;

  return (
    <View style={{flexDirection: 'row', alignItems: 'center', ...style}}>
      <TouchableOpacity
        style={{
          flex: 1,
          justifyContent: 'center',
          alignItems: 'center',
        }}
        activeOpacity={0.8}
        onPress={handlePress}
        disabled={!!disabled || !!classic_hunt}>
        {!!timerStart &&
          !timerFinish &&
          classic_hunt &&
          !huntPaused &&
          current_screen?.currentScreen !== 'HuntFinished' && (
            <TouchableOpacity
              activeOpacity={0.9}
              onPress={() => {
                completionPercent === 100
                  ? Alert.alert(
                      `Great job! Your group has completed all of the hunt challenges`,
                      `Do you want to end the hunt?`,
                      [
                        {
                          text: 'End Hunt',
                          onPress: () => {
                            Alert.alert(
                              'Are you sure?',
                              '',

                              [
                                {
                                  text: 'Yes',
                                  onPress: () => {
                                    setHuntTimerFinish(groupInfo?.groupId);
                                    //finishHunt(groupInfo);
                                  },
                                },
                                {
                                  text: 'Cancel',
                                  onPress: () => console.log('Cancel Pressed'),
                                  style: 'cancel',
                                },
                              ],
                            );
                          },
                        },
                        {
                          text: 'Cancel',
                          onPress: () => console.log('Cancel Pressed'),
                          style: 'cancel',
                        },
                      ],
                    )
                  : Alert.alert(
                      'Do you want to end your hunt early?',
                      'This will end the hunt for all members of your group!',

                      [
                        {
                          text: 'End Hunt',
                          onPress: () => {
                            Alert.alert(
                              'Are you sure?',
                              '',

                              [
                                {
                                  text: 'Yes',
                                  onPress: () => {
                                    setHuntTimerFinish(groupInfo?.groupId);
                                    //finishHunt(groupInfo);
                                  },
                                },
                                {
                                  text: 'Cancel',
                                  onPress: () => console.log('Cancel Pressed'),
                                  style: 'cancel',
                                },
                              ],
                            );
                          },
                        },
                        {
                          text: 'Cancel',
                          onPress: () => console.log('Cancel Pressed'),
                          style: 'cancel',
                        },
                      ],
                    );
              }}>
              <Timer
                seconds={timerLimitMinutes * 60}
                startTime={timerStart}
                containerStyle={{
                  backgroundColor:
                    Date.now() >
                    timerStart + (timerLimitMinutes - 15) * 60 * 1000
                      ? global?.color?.yellow
                      : 'transparent',
                  maxWidth: 100,
                  borderRadius: 10,
                  marginRight: 0,
                }}
                textStyle={{marginLeft: 5, color: global?.color?.white}}
                countUp={false}
                onComplete={() => {
                  Alert.alert(`Time's Up!`);
                  setHuntTimerFinish(groupInfo?.groupId);
                  //finishHunt(groupInfo);
                }}
                completeTime={timerFinish}
                badge={completionPercent == 100}
                highlightTimeLimit={10 * 60}
              />
            </TouchableOpacity>
          )}
        {!timerStart && !classic_hunt && (
          <View
            style={{
              backgroundColor: global?.color?.orange,
              marginRight: 5,
              paddingVertical: 5,
              paddingHorizontal: 0,
            }}>
            <Text
              style={{
                color: global?.color?.white,
                fontFamily: 'Jakarta',
              }}>
              {isBarHunt ? 'See Rank' : `Score: ${score.toLocaleString()}`}
            </Text>
          </View>
        )}
      </TouchableOpacity>
    </View>
  );
};

export default ClassicHuntHeaderTimer;
